export default __webpack_public_path__ + "static/media/Cowboys.da7fd42c.png";